<script lang="ts">
  interface Props {
    status?: 'ACTIVE' | 'SUCCESS' | 'FORFEITED' | 'EXPIRED';
  }

  let { status = 'ACTIVE' }: Props = $props();
</script>

<div>
  <div class="bg-primary-lightBlue pl-1 pr-2 py-1 text-xs rounded-xl w-fit">
    <div class="flex items-center gap-1">
      {#if status === 'ACTIVE'}
        <div class="w-4 h-4 bg-primary-yellow animate-pulse rounded-full"></div>
      {:else if status === 'SUCCESS'}
        <div class="w-4 h-4 bg-green-600 rounded-full"></div>
      {:else if status === 'FORFEITED'}
        <div class="w-4 h-4 bg-red-500 rounded-full"></div>
      {:else if status === 'EXPIRED'}
        <div class="w-4 h-4 bg-black rounded-full"></div>
      {/if}
      {status}
    </div>
  </div>
</div>
